import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
  readOnlyValue: {
    marginTop: "12px",
    padding: "8px 0",
    color: "#424242",
    fontSize: "16px",
    fontWeight: 400,
  },
  readOnlyTableValue: {
    padding: "8px 0",
    color: "#424242",
    fontSize: "16px",
    fontWeight: 400,
  },
}));

